import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MakeBillDialog from '../../components/PurchaseOrderComponents/MakeBillDialog/MakeBillDialog';
import { ACTION_HANDLERS } from '../../components/PurchaseOrderComponents/AddStockActionHandlers';
import { fetchPurchaseInvoiceForSupplier } from '../../redux/modules/accountInvoice/accountInvoice-actions';
import { displayWarning } from '../../redux/modules/warningDialog/warningDialog-actions';
import { bookFormNames, iframeUrlMap } from '../../constants/constants';
import { getStringFromObject } from '../../constants/lodashUtils';
import IframeDialogComponentV2 from '../../components/IframeDialogComponentV2/IframeDialogComponentV2';

class SupplierPurchaseBillContainer extends React.Component {
    componentDidMount() {
        const { match, dispatch } = this.props;
        if (match && match.params) {
            dispatch(fetchPurchaseInvoiceForSupplier(match.params.id, match.params.shopId));
        }
    }

    getiFrameUrl = () => {
        const {
            iframeFormsBase,
        } = this.props;
        return `${iframeFormsBase}${iframeUrlMap.PURCHASE_INVOICE}`;
    }

    handleCloseWithWarning = () => {
        const { dispatch, handleClose } = this.props;
        dispatch(
            displayWarning(
                'Are you sure you want to close? Any unsaved changes will be lost.',
                () => handleClose(),
            ),
        );
    };


    render() {
        const { open, handleClose, loadIframeConfig } = this.props;
        const shouldLoadPurchaseInvoiceIframe = getStringFromObject(bookFormNames.PURCHASE_INVOICE, loadIframeConfig);
        return (
            shouldLoadPurchaseInvoiceIframe ?
                <IframeDialogComponentV2
                    header="Purchase Invoice"
                    open={open}
                    iframeUrl={this.getiFrameUrl()}
                    fullScreen
                    handleClose={this.handleCloseWithWarning}
                /> :
                <MakeBillDialog
                    open={open}
                    saleShopFeild={false}
                    handleClose={handleClose}
                    actionHandlers={ACTION_HANDLERS}
                    type="Purchas Bill"
                />
        );
    }
}

SupplierPurchaseBillContainer.propTypes = {
    loadIframeConfig: PropTypes.object,
    iframeFormsBase: PropTypes.string,
};

SupplierPurchaseBillContainer.defaultProps = {
    loadIframeConfig: {},
    iframeFormsBase: '',
};

const mapStateToProps = state => ({
    loadIframeConfig: getStringFromObject('appConfiguration.loadIframeConfig', state) || true,
    iframeFormsBase: getStringFromObject('appConfiguration.iframeFormsBase', state) || '',
});


SupplierPurchaseBillContainer.propTypes = {
    open: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(SupplierPurchaseBillContainer);
